import IMG1 from './assets/portfolio1.png';
import IMG2 from './assets/portfolio2.png';
import IMG3 from './assets/portfolio3.png';
import IMG4 from './assets/portfolio4.png';
import IMG5 from './assets/portfolio5.png';
import IMG6 from './assets/portfolio6.png';

const data = [
    {
        id: 1,
        image: IMG1,
        title: 'Web YouTube Clone',
        github: 'https://project2-quratulain-shoro.netlify.app/',
        demo: 'https://project2-quratulain-shoro.netlify.app/'
    },
    {
        id: 2,
        image: IMG2,
        title: 'Coffee Shop',
        github: 'https://github.com',
        demo: 'https://project4-quratulain-shoro.netlify.app/'
    },
    {
        id: 3,
        image: IMG3,
        title: 'Online Education Website',
        github: 'https://github.com',
        demo: 'https://project5-quratulain-shoro.netlify.app/'
    },
    {
        id: 4,
        image: IMG4,
        title: 'Airline Website',
        github: 'https://github.com',
        demo: 'https://project6-quratulain-shoro.netlify.app/'
    },
    {
        id: 5,
        image: IMG5,
        title: 'Clothing Brand',
        github: 'https://github.com',
        demo: 'https://project7-quratulain-shoro.netlify.app/'
    },
    {
        id: 6,
        image: IMG6,
        title: 'Fashion Landing Page',
        github: 'https://github.com',
        demo: 'https://project7-quratulain-shoro.netlify.app/'
    }
]

export default data
